import { initialRoleLookupState } from "./roles.state";
import { createReducer, on } from "@ngrx/store";
import { onLoadableLoad, onLoadableSuccess, onLoadableError } from '../../models/index';
import { RoleLookupActions } from "./roles.actions";
import { UserActions } from "../user/user.actions";

export const roleLookupReducer = createReducer(
    initialRoleLookupState,
    on(RoleLookupActions.loadRoles, state => ({...onLoadableLoad(state)})),
    on(RoleLookupActions.loadRolesSuccess, (state, {roles}) => ({...onLoadableSuccess(state), roles: [...roles]})),
    on(RoleLookupActions.loadRolesFailure, (state, {error}) => ({...onLoadableError(state, error)})),
    on(RoleLookupActions.loadCopilotRoles, state => ({ ...state, copilotRolesLoading: true, copilotRolesError: null })),
    on(RoleLookupActions.loadCopilotRolesSuccess, (state, { roles }) => ({ ...state, copilotRolesLoading: false, copilotRoles: [...roles] })),
    on(RoleLookupActions.loadCopilotRolesFailure, (state, { error }) => ({ ...state, copilotRolesLoading: false, copilotRolesError: error })),
    on(UserActions.logout, _ => ({ ...initialRoleLookupState })),
)